import BaseComponent from "../../../../lib/components/BaseComponent";
import LandingLogin from "./LandingLogin";
import Nav from "./Nav";
import RouterElement from "../../../../lib/components/router/RouterElement";

class LandingMain extends BaseComponent {

  render() {
    return <>
      <Nav/>
      <RouterElement route='^$|^landing/login$'><LandingLogin p={this}/></RouterElement>
    </>
  }
}

export default LandingMain;
